import { Box, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";

const ErrorFallBack = () => {
  const intl = useIntl();

  return (
    <Box sx={{ margin: "auto", textAlign: "center" }}>
      <ErrorOutlinedIcon
        sx={{
          color: "error.main",
          textAlign: "center",
          fontSize: "3.5rem",
          marginBottom: 2,
        }}
      />
      <Typography component={"h1"} sx={{ fontSize: "2rem", marginBottom: 2 }}>
        {intl.formatMessage({ id: "FALLBACK_TITLE" })}
      </Typography>
      <Typography
        component={"p"}
        sx={{ fontSize: "1.125rem", width: "80%", margin: "auto" }}
      >
        {intl.formatMessage({ id: "FALLBACK_MESSAGE" })}
      </Typography>
    </Box>
  );
};

export default ErrorFallBack;
